import { Tooltip } from "@mui/material";
import { GridCheckCircleIcon } from "@mui/x-data-grid";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

export const columnsCareGap = [
  { field: 'cipId', headerName: 'CIP ID', width: 150 },
  { field: 'memberId', headerName: 'Member ID', width: 140 },
  { field: 'fullName', headerName: 'Full Name', width: 200 },
  {
    field: 'dateOfBirth',
    headerName: 'Date of Birth',
    width: 150,
    valueGetter: (params) =>
      params?.row?.dateOfBirth ? params.row.dateOfBirth.split('T')[0] : '',
  },
  { field: 'networkName', headerName: 'Network', width: 140 },
  { field: 'email', headerName: 'Email', width: 200 },
  { field: 'phoneNumber', headerName: 'Phone', width: 140 },
  { field: 'mobileNumber', headerName: 'Mobile', width: 140 },
  { field: 'addressLine1', headerName: 'Address Line 1', width: 200 },
  { field: 'addressLine2', headerName: 'Address Line 2', width: 200 },
  { field: 'pcpFullName', headerName: 'PCP Full Name', width: 200 },
  { field: 'locationId', headerName: 'Location ID', width: 120 },
  { field: 'medicalCenter', headerName: 'Medical Center', width: 150 },
];

export const columnsWelcomeCampaign = [
  { field: 'cipId', headerName: 'CIP ID', width: 150 },
  { field: 'campaign', headerName: 'Campaign', width: 130 },
  { field: 'memberId', headerName: 'Member ID', width: 140 },
  { field: 'fullName', headerName: 'Full Name', width: 200 },
  { field: 'patientStatus', headerName: 'Patient Status', width: 150 },
  { field: 'language', headerName: 'Language', width: 120 },
  { field: 'phoneNumber', headerName: 'Phone', width: 140 },
  { field: 'mobileNumber', headerName: 'Mobile', width: 140 },
  { field: 'email', headerName: 'Email', width: 200 },
  { field: 'addressLine1', headerName: 'Address Line 1', width: 200 },
  { field: 'addressLine2', headerName: 'Address Line 2', width: 200 },
  { field: 'campaignOptions', headerName: 'Campaign Options', width: 180 },
  { field: 'campaignStatus', headerName: 'Campaign Status', width: 160 },
  { field: 'relatedComments', headerName: 'Comments', width: 120 },
  { field: 'medicalCenter', headerName: 'Medical Center', width: 150 },
  { field: 'regOepCampOpt', headerName: 'Reg OEP Option', width: 170 },
  { field: 'oepOptions', headerName: 'OEP Options', width: 160 }
];

  export const columnsPCPChanges = [
    { field: "memberId", headerName: "Member ID", flex: 3, filterable: false },
    { field: "insuranceStatus", headerName: "Insurance Status", flex: 3, filterable: false },
    { field: "fullName", headerName: "Member Full Name", flex: 3, filterable: false },
    { field: "dateOfBirth", headerName: "DOB", flex: 3, filterable: false },
    { field: "email", headerName: "Member Email", flex: 3, filterable: false },
    { field: "phoneNumber", headerName: "Member Phone Number", flex: 3, filterable: false },
    { field: "mobileNumber", headerName: "Member Mobile Number", flex: 3, filterable: false },
    { field: "currentPcpFullName", headerName: "PCP Full Name", flex: 3, filterable: false },
    { field: "lastPcpFullName", headerName: "Last PCP", flex: 3, filterable: false },
    { field: "lastGroupName", headerName: "Last Group Name", flex: 3, filterable: false },
    { field: "status", headerName: "Status", flex: 3, filterable: false },
    { field: "medicalCenter", headerName: "Office Location", flex: 3, filterable: false }    
  ];

  export const columnsCodingOpportunities = [
    { field: "memberId", headerName: "Member ID", flex: 3, filterable: false },
    { field: "status", headerName: "Insurance Status", flex: 1.5, filterable: false },
    { field: "memberFullName", headerName: "Member Full Name", flex: 2, filterable: false },
    { field: "dateOfBirth", headerName: "DOB", flex: 2.5, filterable: false },
    { field: "email", headerName: "Member Email", flex: 2, filterable: false },
    { field: "phoneNumber", headerName: "Member Phone Number", flex: 3, filterable: false },
    { field: "mobileNumber", headerName: "Member Mobile Number", flex: 3, filterable: false },
    { field: "pcpAssigned", headerName: "PCP Name", flex: 4, filterable: false },
    {
      field: "RelatidComments",
      headerName: "Related Comments",
      flex: 3,
      filterable: false,
      renderCell: (params) => {
        const count = params.row.RelatidComments?.length ?? 0;
        return `Related Comments (${count})`;
      }
    },
    {
      field: "wns",
      headerName: "Were Notes Signed",
      flex: 3,
      filterable: false,
      renderCell: (params) => {
        const value = params.row.WereNotesSingned;
        return value === true ? (
          <Tooltip title="Yes">
            <CheckCircleIcon style={{ color: "green" }} />
          </Tooltip>
        ) : value === false ? (
          <Tooltip title="No">
            <CancelIcon style={{ color: "red" }} />
          </Tooltip>
        ) : null;
      }
    },
    {
      field: "wcsc",
      headerName: "Was charge slip completed?",
      flex: 3,
      filterable: false,
      renderCell: (params) => {
        const value = params.row.Waschargeslipcompleted;
        return value === true ? (
          <Tooltip title="Yes">
            <GridCheckCircleIcon style={{ color: "green" }} />
          </Tooltip>
        ) : value === false ? (
          <Tooltip title="No">
            <CancelIcon style={{ color: "red" }} />
          </Tooltip>
        ) : null;
      }
    }
  ]

